// 综合性运动会-赛程-常规赛程
const CSMeetRegularScheduleIndex = () =>
  import(
    /* webpackChunkName: "CSMeetRegularScheduleIndex" */ '@platfrom/compreSportsMeet/schedule/index.vue'
  )
// 综合性运动会-赛程-运动员赛程
const CSMeetEventPlayersScheduleIndex = () =>
  import(
    /* webpackChunkName: "CSMeetEventPlayersScheduleIndex" */ '@platfrom/compreSportsMeet/schedule/eventPlayers.vue'
  )

// 综合性运动会-赛程-项目阶段
const CSMeetEventPhaseIndex = () =>
  import(
    /* webpackChunkName: "CSMeetEventPhaseIndex" */ '@platfrom/compreSportsMeet/schedule/eventPhase.vue'
  )

// 综合性运动会-奖牌-奖牌榜
const CSMeetMedalTallyIndex = () =>
  import(
    /* webpackChunkName: "CSMeetMedalTallyIndex" */ '@platfrom/compreSportsMeet/medal/medalTally/index.vue'
  )

// 综合性运动会-奖牌-奖牌明细
const CSMeetMedalDetailListIndex = () =>
  import(
    /* webpackChunkName: "CSMeetMedalDetailListIndex" */ '@platfrom/compreSportsMeet/medal/medalDetailList/index.vue'
  )

// 综合性运动会-项目列表
const CSMeetBigSportsIndex = () =>
  import(
    /* webpackChunkName: "CSMeetBigSportsIndex" */ '@platfrom/compreSportsMeet/bigSports/index.vue'
  )

// 综合性运动会-项目详情
const CSMeetSportsDetailIndex = () =>
  import(
    /* webpackChunkName: "CSMeetSportsDetailIndex" */ '@platfrom/compreSportsMeet/sportsDetail/index.vue'
  )

// 综合性运动会-项目详情 -> 赛程
const CSMeetSportsDetailScheduleDate = () =>
  import(
    /* webpackChunkName: "CSMeetSportsDetailScheduleDate" */ '@platfrom/compreSportsMeet/sportsDetail/childPage/scheduleDate.vue'
  )

// 综合性运动会 赛程详情
const CSMeetSportDetailScheduleDetail = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetail" */ '@platfrom/compreSportsMeet/scheduleDetail/index.vue'
  )

// 综合性运动会-赛程详情 -> 出场名单
const CSMeetSportDetailScheduleDetailStartList = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetailStartList" */ '@platfrom/compreSportsMeet/scheduleDetail/childPage/startList.vue'
  )

// 综合性运动会-赛程详情 -> 本场数据
const CSMeetSportDetailScheduleDetailLocalData = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetailLocalData" */ '@platfrom/compreSportsMeet/scheduleDetail/childPage/localData.vue'
  )

// 综合性运动会-赛程详情 -> 数据分析
const CSMeetSportDetailScheduleDetailDataAnalysis = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetailDataAnalysis" */ '@platfrom/compreSportsMeet/scheduleDetail/childPage/dataAnalysis.vue'
  )

// 综合性运动会-赛程详情 -> 数据战报
const CSMeetSportDetailScheduleDetailDataBattleReport = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetailDataBattleReport" */ '@platfrom/compreSportsMeet/scheduleDetail/childPage/dataBattleReport.vue'
  )

// 综合性运动会-项目详情 -> 参赛名单
const CSMeetSportsDetailPlayer = () =>
  import(
    /* webpackChunkName: "CSMeetSportsDetailPlayer" */ '@platfrom/compreSportsMeet/sportsDetail/childPage/player.vue'
  )

// 综合性运动会-项目详情 -> 综合成绩
const CSMeetSportsDetailCompreScore = () =>
  import(
    /* webpackChunkName: "CSMeetSportsDetailCompreScore" */ '@platfrom/compreSportsMeet/sportsDetail/childPage/compreScore.vue'
  )

// 综合性运动会-项目详情 -> 奖牌
const CSMeetSportsDetailMedalList = () =>
  import(
    /* webpackChunkName: "CSMeetSportsDetailMedalList" */ '@platfrom/compreSportsMeet/sportsDetail/childPage/medalList.vue'
  )

// 综合性运动会-项目详情 -> 数据分析
const CSMeetSportsDetailEventDataAnalysis = () =>
  import(
    /* webpackChunkName: "CSMeetSportsDetailEventDataAnalysis" */ '@platfrom/compreSportsMeet/sportsDetail/childPage/eventDataAnalysis.vue'
  )

// 综合性运动会-代表团
const CSMeetDelegationIndex = () =>
  import(
    /* webpackChunkName: "CSMeetDelegationIndex" */ '@platfrom/compreSportsMeet/delegation/index.vue'
  )

// 综合性运动会-代表团详情
const CSMeetDelegationDetailIndex = () =>
  import(
    /* webpackChunkName: "CSMeetDelegationDetailIndex" */ '@platfrom/compreSportsMeet/delegationDetail/index.vue'
  )

// 综合性运动会-代表团详情 -> 赛程
const CSMeetDelegationDetailSchedule = () =>
  import(
    /* webpackChunkName: "CSMeetDelegationDetailIndex" */ '@platfrom/compreSportsMeet/delegationDetail/childPage/schedule.vue'
  )

// 综合性运动会-代表团详情 -> 参赛选手
const CSMeetDelegationDetailPlayer = () =>
  import(
    /* webpackChunkName: "CSMeetDelegationDetailIndex" */ '@platfrom/compreSportsMeet/delegationDetail/childPage/player.vue'
  )

// 综合性运动会-代表团详情 -> 获奖明细
const CSMeetDelegationDetailMedalList = () =>
  import(
    /* webpackChunkName: "CSMeetDelegationDetailIndex" */ '@platfrom/compreSportsMeet/delegationDetail/childPage/medalList.vue'
  )

// 综合性运动会-运动员
const CSMeetPlayerIndex = () =>
  import(
    /* webpackChunkName: "CSMeetPlayersIndex" */ '@platfrom/compreSportsMeet/player/index.vue'
  )

// 综合性运动会-运动员详情
const CSMeetPlayerDetailIndex = () =>
  import(
    /* webpackChunkName: "CSMeetPlayerDetailIndex" */ '@platfrom/compreSportsMeet/player/playerDetail.vue'
  )

// 综合性运动会-纪录
const CSMeetRecordIndex = () =>
  import(
    /* webpackChunkName: "CSMeetRecordIndex" */ '@platfrom/compreSportsMeet/records/index.vue'
  )

// 综合性运动会-场馆
const CSMeetVenueIndex = () =>
  import(
    /* webpackChunkName: "CSMeetVenueIndex" */ '@platfrom/compreSportsMeet/venue/index.vue'
  )

// 综合性运动会-播出单
const CSMeetBroadcastListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageBroadcastListIndex" */ '@platfrom/commonPage/broadcastList/index.vue'
  )

// 综合性运动会-数据包装
const CSMeetDataPackagListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageDataPackagListIndex" */ '@platfrom/commonPage/dataPackagList/index.vue'
  )

// 特殊大项的赛果

// 综合性运动会-赛程详情 -> 全能成绩
const CSMeetSportDetailScheduleDetailOtherTab_combinedResult = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetailOtherTab_combinedResult" */ '@platfrom/compreSportsMeet/scheduleDetail/childPage/otherTab/combinedResult.vue'
  )

// 综合性运动会-赛程详情 -> 单项成绩
const CSMeetSportDetailScheduleDetailOtherTab_singleResult = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetailOtherTab_singleResult" */ '@platfrom/compreSportsMeet/scheduleDetail/childPage/otherTab/singleResult.vue'
  )

// 综合性运动会-赛程详情 -> 综合成绩
const CSMeetSportDetailScheduleDetailOtherTab_compreResult = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetailOtherTab_compreResult" */ '@platfrom/compreSportsMeet/scheduleDetail/childPage/otherTab/compreResult.vue'
  )

// 综合性运动会-赛程详情 -> 团体成绩|混合成绩
const CSMeetSportDetailScheduleDetailOtherTab_teamResult = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetailOtherTab_teamResult" */ '@platfrom/compreSportsMeet/scheduleDetail/childPage/otherTab/teamResult.vue'
  )

// 综合性运动会-赛程详情 -> 小组成绩|轮次成绩
const CSMeetSportDetailScheduleDetailOtherTab_groupResult = () =>
  import(
    /* webpackChunkName: "CSMeetSportDetailScheduleDetailOtherTab_groupResult" */ '@platfrom/compreSportsMeet/scheduleDetail/childPage/otherTab/groupResult.vue'
  )

// 综合性运动会-节目单
const CSMeetProgramListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageProgramListIndex" */ '@platfrom/commonPage/programList/index.vue'
  )

export default {
  CSMeetRegularScheduleIndex,
  CSMeetEventPlayersScheduleIndex,
  CSMeetEventPhaseIndex,
  CSMeetMedalTallyIndex,
  CSMeetMedalDetailListIndex,
  CSMeetBigSportsIndex,
  CSMeetSportsDetailIndex,
  CSMeetSportsDetailScheduleDate,
  CSMeetSportDetailScheduleDetail,
  CSMeetSportDetailScheduleDetailStartList,
  CSMeetSportDetailScheduleDetailLocalData,
  CSMeetSportDetailScheduleDetailDataAnalysis,
  CSMeetSportDetailScheduleDetailDataBattleReport,
  CSMeetSportsDetailPlayer,
  CSMeetSportsDetailCompreScore,
  CSMeetSportsDetailMedalList,
  CSMeetSportsDetailEventDataAnalysis,
  CSMeetDelegationIndex,
  CSMeetDelegationDetailIndex,
  CSMeetDelegationDetailSchedule,
  CSMeetDelegationDetailPlayer,
  CSMeetDelegationDetailMedalList,
  CSMeetPlayerIndex,
  CSMeetPlayerDetailIndex,
  CSMeetRecordIndex,
  CSMeetVenueIndex,
  CSMeetBroadcastListIndex,
  CSMeetDataPackagListIndex,
  CSMeetProgramListIndex,
  CSMeetSportDetailScheduleDetailOtherTab_combinedResult,
  CSMeetSportDetailScheduleDetailOtherTab_singleResult,
  CSMeetSportDetailScheduleDetailOtherTab_compreResult,
  CSMeetSportDetailScheduleDetailOtherTab_teamResult,
  CSMeetSportDetailScheduleDetailOtherTab_groupResult,
}
